/**
 * Created by Christof Sander on 02.03.2017.
 */

const utils = require('../../lib/utils');

module.exports = {
	config: {
		isSortable: false,
		directions: [
			'asc',
			'desc',
			'none'
		],
		sortByDragging: false,
		draggable: {
			durations: {
				moveElement: .3
			},
			cursor: 'move'
		},
		supportLazyloading: true,
		supportOnScrollLazyloading: true,
		lazyloadStepSize: 40,
		preventSortOfField: {},
		buttonContext: 'entity',
		showHead: false,
		showInsertButton: false,
		showColorCodedRows: true,
		showAllBorders: true,
		showDelimiterBorders: false,
		showScrollBarAnyway: false,
		renderEmptyBeforReady: false,
		preventRender: false,
		inline: false,
		rowActionsProperties: {
			// colWidth: '80px',
			colSpan: 1,
			rowSpan: 1
		},
		rowActions: {
			delete: false,
			edit: false,
			customs: []
		},
		forceResourceFilterPreparation: false,
		customColActionsFile: false,
		usage: '',
		isSelectionSource: false,
		isMultiSelect: true,
		isSelectionTarget: false,
		nrOfColumnsPerRowIndex: {},
		maxNrOfColumns: 0,

		/**
		 * useSelectionObjectFormat => true uses objects instead of arrays as selection format.
		 * this adds the possibility of an internal value mapping (see useSelectionObjectKeyAttribute flag) (e.g., use the routeID as key and the productID as value of the mblxProduct-selector table.)
		 */
		useSelectionObjectFormat: false,
		/**
		 * only works in combination with useSelectionObjectFormat and has to be unique within the resources used by this table.
		 * with this flag being empty, the data format of the selectionObject will be of the following format:
		 * 		{ <primaryKey>: <primaryKey>, ... }
		 * if this flag is set the format would look like:
		 * 		{ <value of useSelectionObjectKeyAttribute>: <primaryKey>, ... }
		 */
		useSelectionObjectKeyAttribute: ''
	},

	model: {
		resourceFilters: {
			offset: 0,
			order: [],
			filters: {}
		},
		entityList: {},
		entityListByIndex: [],
		selectedRowIDs: [],
		selectedEntityList: {},
		lazyloadingInEffect: false,
		onScrollTimeout: false,
		keepFirstPageForcedLimit: 0,
		$table: false,
		lastScrollPosition: 0,
		langCode: ''
	},

	events: {
		order: {
			type: 'click',
			selector: 'thead tr td, thead tr td *',
			action: function(event){
				event.preventDefault();
				event.stopImmediatePropagation();

				var self = event.data.component;
				var $target = $(event.target);
				var $realTarget = $target.closest('td');
				var fieldCode, direction, directionIndex;

				if(self.config.isSortable && (fieldCode = $realTarget.data('fieldCode')) !== undefined && !(self.config.preventSortOfField || {})[fieldCode]){
					direction       = $target.data('orderDirection');
					directionIndex  = self.config.directions.indexOf(direction) + 1;
					if(directionIndex >= self.config.directions.length) directionIndex = 0;
					direction = self.config.directions[directionIndex];

					if(!utils.keyboard.keysActive('strg')){
						self.model.resourceFilters.order = [];
					}

					// change direction of sort field
					var o;
					var orderElementFound = false;
					for(o in self.model.resourceFilters.order){
						if(self.model.resourceFilters.order[o].fieldCode === fieldCode){
							if(direction === 'none'){
								self.model.resourceFilters.order.splice(o, 1);
							}
							else {
								self.model.resourceFilters.order[o].direction = direction;
							}
							orderElementFound = true;
							break;
						}
					}

					if(!orderElementFound && direction !== 'none'){
						self.model.resourceFilters.order.push({
							fieldCode: fieldCode,
							direction: direction
						});
					}

					self.refreshData();
				}
			}
		},

		lazyloadClick: {
			type: 'click',
			selector: 'button[data-field-type="lazyload"]',
			action: function(event){
				event.preventDefault();
				event.stopImmediatePropagation();

				event.data.component.lazyloadNext();
			}
		},

		lazyloadScroll: {
			type: 'mousewheel DOMMouseScroll',
			action: function(event){
				var self = event.data.component;

				if(self.config.supportOnScrollLazyloading){
					var $scrollContainer, $fullHeightContainer;

					if(typeof self.get$ScrollContainer === 'function'){
						$scrollContainer = self.get$ScrollContainer(event);
					} else {
						$scrollContainer = self.$;
					}

					if(typeof self.get$FullHeightContainer === 'function'){
						$fullHeightContainer = self.get$FullHeightContainer(event);
					} else {
						$fullHeightContainer = $(event.target).closest('table');
					}

					self.onScrollLazyload($scrollContainer, $fullHeightContainer);
				}
			}
		},

		showColumnDescription: {
			type: 'mouseenter',
			selector: '.base_tableSimple_col',
			action: function(event){
				var self = event.data.component;
				var $target = $(event.target).closest('.base_tableSimple_col');
				if($target.length > 0){
					var modelFieldIndex = $target.data('modelFieldIndex');
					if(modelFieldIndex){
						self.showColumnDescription(modelFieldIndex);
					}
				}
			}
		},

		hideColumnDescription: {
			type: 'mouseleave',
			selector: '.base_tableSimple_col',
			action: function(event){
				event.data.component.hideColumnDescription();
			}
		},

		action: {
			type: 'click',
			action: function(event) {
				var $target;
				var $row;
				var rowID;
				var rowData;
				var self = event.data.component;

				if(self.customClickHandler(event)){
					event.preventDefault();
					event.stopImmediatePropagation();
				} else if(
					($target = $(event.target).closest('button')).length > 0 &&
					($row = $(event.target).closest('tbody')).length > 0 &&
					(rowID = $row.data('rowId'))
				){
					if(rowData = self.getRowData(rowID)){
						event.preventDefault();
						event.stopImmediatePropagation();
						var fieldType = $target.data('fieldType') || '';
						if(fieldType && typeof self[fieldType] === 'function'){
							self[fieldType](rowID, rowData, $target.data('buttonMode'));
						}
					}
				} else if(($target = $(event.target).closest('tbody')).length > 0){
					if((rowID = $target.data('rowId'))){
						var rowData;
						if(rowData = self.getRowData(rowID)){
							event.preventDefault();
							event.stopImmediatePropagation();
							self.showEdit(rowID, rowData)
						}
					}
				} else if(($target = $(event.target).closest('button')).length > 0){
					if($target.data('fieldType') === 'showInsert'){
						event.preventDefault();
						event.stopImmediatePropagation();
						self.showInsert();
					} else if($target.data('fieldType') === 'delete'){
						event.preventDefault();
						event.stopImmediatePropagation();
						self.delete();
					}
				}
			}
		}
	},

	methods: {
		prepare: function(storage, isServer){
			if(this.config.isSelectionTarget){
				this.config.rowActions.delete = true
				this.config.rowActions.edit = false
			} else if(this.config.rowActions.delete && !storage.user.hasAccessTo(this.config.privilegeBase + ':delete', this.scope)){
				this.config.rowActions.delete = false
			}

			// handle config conflicts
			if(this.config.sortByDragging){
				this.config.isSortable = false;
				this.config.supportLazyloading = false;
				this.config.supportOnScrollLazyloading = false;
			}

			// estimate max number of cols per row (e.g., useful for span of group entries)
			this.config.nrOfColumnsPerRowIndex = {}
			this.config.maxNrOfColumns = 0
			for(var f in this.model.fields){
				this.config.nrOfColumnsPerRowIndex[(this.model.fields[f].config || {}).rowIndex || 0] = (this.config.nrOfColumnsPerRowIndex[(this.model.fields[f].config || {}).rowIndex || 0] || 0) + 1
				this.config.maxNrOfColumns = Math.max(this.config.maxNrOfColumns, this.config.nrOfColumnsPerRowIndex[(this.model.fields[f].config || {}).rowIndex || 0])
			}

			this.onPrepareDone(storage, isServer)
		},

		onPrepareDone: function(storage, isServer){
			// NOTE: overwrite if necessary
		},

		showInsert: function(){
			// NOTE: overwrite if necessary
		},

		showEdit: function(rowID, rowData, buttonMode){
			// NOTE: overwrite if necessary
		},

		delete: function(rowID, rowData, buttonMode){
			// NOTE: overwrite if necessary
		},

		addEntity: function(entity){
			// NOTE: overwrite if necessary
		},

		sanitizeEntity: function(refEntity){
			// NOTE: overwrite if necessary
		},

		identifyResourceData: function(){
			var resourceAlias = (this.config.resourceRelationConfig || {}).alias
			var resourceAliasContainer = (this.config.resourceRelationConfig || {}).aliasContainer
			var resourceData

			if(resourceAliasContainer && resourceAlias){
				resourceData = ((this.resourceData.data || {})[resourceAliasContainer] || {})[resourceAlias] || {}
			} else {
				resourceData = this.resourceData
			}

			return resourceData
		},

		sanitizeResources: function(storage){

			var self 			= this;
			var resourceData 	= this.identifyResourceData()
			var entityID, entityKey, entity, entityAttributes;
			var prevEntity;
			var domEntityPresent;

			// getFilteredRowIDs is used to get the full non-lazy-loaded list of attributes for further manipulation outside the core table mechanics.
			// in this case no resource preparation is necessary.
			if(self.model.preventResourceSanitationByGetFilteredRowIDs) return;

			if(!this.config.isReady && !resourceData.initialized){
				this.model.entityList = {};
				this.model.entityListByIndex = {};
				this.model.langCode = (((this.storage || {}).user || {}).data || {}).langCode || 'de-at';
			}

			var entityList			= this.model.entityList;
			var entityListByIndex	= this.model.entityListByIndex;

			if(resourceData && resourceData.data && (!resourceData.initialized || self.model.lazyloadingInEffect)){
				resourceData.initialized = true;

				// prevent primaryKey fields if necessary
				if(!self.model.fieldsInitialized){
					var showIDs = false
					var user = (storage|| {}).user
					if(user) {
						showIDs = user.hasRoleOption('showIDs', this.scope)
					}

					if(!showIDs && (resourceData.data || []).length > 0){
						self.model.fieldsInitialized = true;
						var primaryKey = (resourceData.data[Object.keys(resourceData.data).shift()] || {}).primaryKey || 'id';
						for(var f in self.model.fields || []){
							if(self.model.fields[f].fieldCode === primaryKey){
								self.model.fields[f].preventTableField = true;
								self.model.fields[f].showTableFieldAsRowTitle = true;
							}
						}
					}
				}

				// prepare resource data and entity list
				var offset = (self.model.resourceFilters || {}).offset || 0;
				for(var d in resourceData.data || []){
					entity = resourceData.data[d] || {};
					entityAttributes = entity.attributes || {};
					entityID = entityAttributes[entity.primaryKey || 'id']
					entityKey = 'entityID_' + entityID;
					domEntityPresent = entityList[entityKey] && entityList[entityKey] !== -1;
					entity.index = (d * 1) + offset;
					self.sanitizeEntity(entity, prevEntity)
					delete entityList[entityKey];
					entityList[entityKey] = entity;
					entityListByIndex[entity.index] = entity;

					// remember selection state of entities during search or scrolling
					if(self.config.isSelectionSource && self.config.usage === 'selection' && self.model.selectedRowIDs && utils.indexOf(self.model.selectedRowIDs, `${entityID}`) > -1){
						entity.selected = true
					}

					// add lazyloaded entities if necessary
					if(self.config.isReady && !domEntityPresent){
						self.addEntity(entity, prevEntity);
					}

					// provide previously added entity for addEntity method
					prevEntity = entity
				}
			}

			self.model.keepFirstPage = false;
			self.onResourceSanitized();
			if(storage.isClient){
				self.callHandler('refreshResources');
			}
		},

		onResourceSanitized: function(){},

		getResourceFilters: function(storage, resourceFilters, actionKey, fieldCode){
			if(utils.collectionSize(this.model.resourceFilters) > 0){
				resourceFilters = resourceFilters || {};
				utils.refReplace(resourceFilters, this.model.resourceFilters);
			}
			if(actionKey === 'refreshResources' || (this.config.forceResourceFilterPreparation && !fieldCode)){
				if(this.config.supportLazyloading){
					resourceFilters = resourceFilters || {};
					if(this.model.keepFirstPageForcedLimit){
						resourceFilters.limit = this.model.keepFirstPageForcedLimit;
						this.model.keepFirstPageForcedLimit = 0;
					} else if(!resourceFilters.limit) {
						resourceFilters.limit = this.config.lazyloadStepSize;
					} else if(this.model.lazyloadingInEffect && resourceFilters.limit > this.config.lazyloadStepSize){
						resourceFilters.offset += resourceFilters.limit - this.config.lazyloadStepSize
						resourceFilters.limit = this.config.lazyloadStepSize
					}
				}

				this.model.resourceFilters = resourceFilters;
				this.sanitizeResourceFilters(storage, resourceFilters, actionKey, true);
			} else {
				this.sanitizeResourceFilters(storage, resourceFilters, actionKey, false);
			}

			return resourceFilters;
		},

		/**
		 * this function may be overwritten to be able to sanitize the resourceFilters (param) by reference.
		 *
		 * @param storage			{} - actual storage
		 * @param resourceFilters	{} - actual resourceFilters
		 * @param actionKey			string - actual aktionKey
		 */
		sanitizeResourceFilters: function(storage, resourceFilters, actionKey){},

		onFilterChanged: function(filters, preventRefresh, forceRefresh){
			var isEqual = utils.isEqual(this.model.resourceFilters.filters, filters);
			if(forceRefresh || (!preventRefresh && !isEqual)){
				this.model.resourceFilters.filters = utils.simpleCopy(filters || {});
				this.model.lastScrollPosition = 0;
				this.refreshData();
			}
		},

		keepFirstPage: function(){
			this.model.keepFirstPageForcedLimit = utils.collectionSize(this.model.entityList);
			// prevent limit errors on auto-refresh
			if(this.model.keepFirstPageForcedLimit < this.config.lazyloadStepSize){
				this.model.keepFirstPageForcedLimit = this.config.lazyloadStepSize;
			}
			if(this.$.is(':visible')){
				this.model.lastScrollPosition = this.$.scrollTop();
			}
		},

		refreshData: function(keepFirstPage, refreshTriggerOptions){
			if(keepFirstPage){
				this.keepFirstPage();
			}
			this.resetData();
			this.refresh(true, refreshTriggerOptions || {});
		},

		resetData: function(){
			this.model.entityList = {};
			this.model.resourceFilters.offset = 0;
		},

		onScrollLazyload: function($scrollContainer, $fullHeightContainer, deltaTime){
			if(this.config.supportOnScrollLazyloading){
				var delta;
				if(deltaTime === undefined) 	deltaTime = 100;
				if(this.model.onScrollTimeout) 	clearTimeout(this.model.onScrollTimeout);

				if(!$scrollContainer){
					if(typeof this.get$ScrollContainer === 'function'){
						$scrollContainer = this.get$ScrollContainer();
					} else {
						$scrollContainer = this.$;
					}
				}

				if(!$fullHeightContainer){
					if(typeof this.get$FullHeightContainer === 'function'){
						$fullHeightContainer = this.get$FullHeightContainer();
					} else {
						$fullHeightContainer = this.$.find('table');
					}
				}

				if(deltaTime > 0){
					this.model.onScrollTimeout = setTimeout(function(self, $scrollContainer, $fullHeightContainer){
						self.onScrollLazyload($scrollContainer, $fullHeightContainer, 0);
					}, deltaTime, this, $scrollContainer, $fullHeightContainer);
				} else {
					if(
						$scrollContainer.length > 0 &&
						$fullHeightContainer.length > 0 &&
						(delta = ($fullHeightContainer.height() - $scrollContainer.height() - $scrollContainer.scrollTop())) <= 50
					){
						this.lazyloadNext();
					}
				}
			}
		},

		lazyloadNext: function(){
			var self = this;

			var resourceData = self.identifyResourceData()

			// prevent lazyloading requests if the last lazyload contained no data
			if(self.config.supportLazyloading && !self.model.lazyloadingInEffect && (resourceData.data || []).length > 0){
				self.model.lazyloadingInEffect = true;
				self.model.resourceFilters.offset = Math.min(self.model.resourceFilters.offset + self.config.lazyloadStepSize, Object.keys(self.model.entityList).length);
				self.onBeforeLazyLoad();
				self.performAction('refreshResources')
					.then(function(){
						self.model.lazyloadingInEffect = false;
						self.onAfterLazyLoad();
					})
					.fail(function(){
						self.model.lazyloadingInEffect = false;
						self.onAfterLazyLoad(true);
					})
				;

			}
		},

		onBeforeLazyLoad: function(){
			// NOTE: OVERWRITE THIS IF NECESSARY
		},
		onAfterLazyLoad: function(errorOccurred){
			// NOTE: OVERWRITE THIS IF NECESSARY
		},

		/**
		 * return the row data identified by the given entityID.
		 *
		 * @param entityID				int - id
		 * @returns 					data or false in an error case.
		 */
		getRowData: function(entityID){
			if(entityID !== undefined){
				entityID = 'entityID_' + entityID
				const entity = (this.model.entityList || {})[entityID]
				const selectedEntity = (this.model.selectedEntityList || {})[entityID]

				const rowIsPresentInDataSet = !entity && selectedEntity
				const result = entity || selectedEntity || false
				if(result){
					return {
						...result,
						...{rowIsPresentInDataSet}
					}
				}
			}

			return false;
		},

		getRowIDByIndex: function(entityIndex){
			const data = (this.model.entityListByIndex || {})[entityIndex || -1] || {}
			if((data.attributes || {})[data.primaryKey || 'NO_PK_FOUND']){
				return data.attributes[data.primaryKey]
			}
			return -1
		},

		getNrOfRows: function(){
			return Object.keys(this.model.entityList || {}).length
		},

		showColumnDescription: function(modelFieldIndex){
			if(modelFieldIndex){
				var field = (this.model.fields || {})[modelFieldIndex];
				var info = (((field || {}).lang || {})[this.model.langCode || 'de-at'] || {}).info || '';
				if(info){
					this.triggerClosest('showColumnDescription', { info });
				}
			}
		},

		hideColumnDescription: function(){
			this.triggerClosest('hideColumnDescription');
		},

		toggleRowSelection: function(rowID, rowData){
			let result = false

			if(rowID && this.config.usage === 'selection'){
				var entityKey = `entityID_${rowID}`;
				var refEntityContainer = this.model.entityList;
				var refEntityListByIndexContainer = this.model.entityListByIndex;
				var refSelectedEntityContainer = this.model.selectedEntityList;
				var useSelectionObjectFormat = this.config.useSelectionObjectFormat
				var useSelectionObjectKeyAttribute = this.config.useSelectionObjectKeyAttribute

				if(utils.isEmpty(this.model.selectedRowIDs)){
					if(useSelectionObjectFormat){
						this.model.selectedRowIDs = {}
					} else {
						this.model.selectedRowIDs = []
					}
				}

				var selectedRowIndex = utils.indexOf(this.model.selectedRowIDs, `${rowID}`);
				var isEntitySelected = selectedRowIndex > -1;

				// deselect previous node if necessary
				if(!this.config.isMultiSelect && !isEntitySelected) {
					let previousSelectedRowID;
					if(useSelectionObjectFormat){
						previousSelectedRowID = Object.keys(this.model.selectedRowIDs)[0];
						this.model.selectedRowIDs = {}
					} else {
                        previousSelectedRowID = this.model.selectedRowIDs[0];
						this.model.selectedRowIDs = []
					}
					this.model.selectedEntityList = {}

					if(previousSelectedRowID){
						const previousEntityKey = `entityID_${previousSelectedRowID}`
						if(refEntityContainer[previousEntityKey]){
							if(this.config.isSelectionSource){
								refEntityContainer[previousEntityKey].selected = false;
								this.$.find(`.base_tableSimple_row[data-row-id="${previousSelectedRowID}"]`).removeClass('selected');
							} else if(this.config.isSelectionTarget){
								refEntityListByIndexContainer.splice(refEntityContainer[previousEntityKey].index, 1);
							}
						}
					}
				}

				if(isEntitySelected){
					if(useSelectionObjectFormat){
						delete this.model.selectedRowIDs[selectedRowIndex];
					} else {
						this.model.selectedRowIDs.splice(selectedRowIndex, 1);
					}

					if(this.config.isSelectionSource){
						delete refSelectedEntityContainer[entityKey];
						if(refEntityContainer[entityKey]){
							refEntityContainer[entityKey].selected = false;
							this.$.find(`.base_tableSimple_row[data-row-id="${rowID}"]`).removeClass('selected');
						}
						this.sourceSelectionChanged();
					} else if(this.config.isSelectionTarget){
						refEntityListByIndexContainer.splice(refEntityContainer[entityKey].index, 1);
						this.refreshOrder();
						this.selectionChanged();
						this.refresh(false);
					}
				} else if(rowData) {
					if(useSelectionObjectFormat){
						var rowKey = `${rowID}`
						if(useSelectionObjectKeyAttribute){
							rowKey = `${rowData.attributes[useSelectionObjectKeyAttribute]}`
						}
						this.model.selectedRowIDs[rowKey] = `${rowID}`;
					} else {
						this.model.selectedRowIDs.push(`${rowID}`);
					}

					if(this.config.isSelectionSource && refEntityContainer[entityKey]){
						refSelectedEntityContainer[entityKey] = refEntityContainer[entityKey];
						refEntityContainer[entityKey].selected = true;
						this.$.find(`.base_tableSimple_row[data-row-id="${rowID}"]`).addClass('selected');
						this.sourceSelectionChanged();
						result = true
					} else if(this.config.isSelectionTarget){
						delete rowData.selected;
						refEntityListByIndexContainer.push(rowData);
						this.refreshOrder();
						this.selectionChanged();
						this.refresh(false);
					}
				}
			}

			return result
		},



		////////////////////////////////////////////////////////
		///// DRAGGABLE ROWS
		////////////////////////////////////////////////////////

		initDraggables: function($element){
			if(!this.config.sortByDragging) return;

			this.model.draggable = {};
			// this.model.draggable.performedOffsets = {};
			this.model.draggable.$container = $element.find('> table');
			this.model.draggable.$elements = this.model.draggable.$container.find('tbody');
			this.model.draggable.container = {
				width:  this.model.draggable.$container.width(),
				height: this.model.draggable.$container.height()
			};
			this.model.draggable.elements = {
				width:  this.model.draggable.$elements.first().outerWidth(true),
				height: this.model.draggable.$elements.first().outerHeight(true)
			};
			this.model.draggable.dirtyElements      = {};
			this.model.draggable.dirtyElementsMove  = {};
			this.model.draggable.finalDirtyElements = {};
			this.model.draggable.resetElements      = {};
			this.model.draggable.indexMapping = {};
			this.model.draggable.nrOfElements       = this.model.draggable.$elements.length;
			this.model.draggable.nrOfElementsPerRow = parseInt(this.model.draggable.container.width / this.model.draggable.elements.width);
			this.model.draggable.nrOfRows           = this.model.draggable.nrOfElements / this.model.draggable.nrOfElementsPerRow;
			var nrOfRows;
			if((nrOfRows = parseInt(this.model.draggable.nrOfRows)) < this.model.draggable.nrOfRows){
				this.model.draggable.nrOfRows = ++nrOfRows;
			}

			this.model.draggable.initialized = true;
			this.model.draggable.started = false;

			Draggable.create(
				this.model.draggable.$elements,
				{
					bounds:             this.model.draggable.$container,
					cursor:             this.config.draggable.cursor || 'pointer',
					minimumMovement:    6,
					onClick:            this.onClick,
					onClickParams:      [this],
					onDragStart:        this.onDragStart,
					onDragStartParams:  [this],
					onDrag:             this.onDrag,
					onDragParams:       [this],
					onDragEnd:          this.onDragEnd,
					onDragEndParams:    [this],
					onRelease:          this.onRelease,
					onReleaseParams:    [this]
				}
			);
		},

		onClick: function(component){
			if(!component.config.sortByDragging) return;

			$(this.target).css('z-index', 'initial');
		},

		onDragStart: function(component){
			if(!component.config.sortByDragging) return;

			if(component.model.draggable.initialized){
				component.model.draggable.started = true;
				var $target = $(this.target);
				$target.addClass('dragInCharge');
				
				var index = parseInt($target.attr('data-row-index'));
				var i = component.model.entityListByIndex[index].index;
				
				component.model.draggable.dirtyElements[index]      = {};
				component.model.draggable.dirtyElementsMove[index]  = {};
				if(component.model.draggable.finalDirtyElements[index] == undefined){
					component.model.draggable.finalDirtyElements[index] = {};
				}
				component.model.draggable.resetElements[index]      = {};
				component.model.draggable.position = {
					index:  index,
					row:    parseInt(index / component.model.draggable.nrOfElementsPerRow),
					col:    (index % component.model.draggable.nrOfElementsPerRow),
					i:      i,
					r:      parseInt(i / component.model.draggable.nrOfElementsPerRow),
					c:      (i % component.model.draggable.nrOfElementsPerRow)
				};
			}
		},
		onDrag: function(component){
			if(!component.config.sortByDragging) return;
			
			if(component.model.draggable.initialized && component.model.draggable.started){
				var pos             = component.model.draggable.position || {};
				var dirties         = component.model.draggable.dirtyElements[pos.index];
				// var finalDirties    = component.model.draggable.finalDirtyElements[pos.index];
				var dirtyIndexes    = Object.keys(dirties);

				var offset = {
					r: this.y / component.model.draggable.elements.height,
					c: this.x / component.model.draggable.elements.width,
					rows: Math.round(this.y / component.model.draggable.elements.height),
					cols: Math.round(this.x / component.model.draggable.elements.width)
				};
				offset.index = (offset.rows * component.model.draggable.nrOfElementsPerRow);
				offset.index += offset.cols;

				// correct offset boundaries
				offset.index    = Math.max(-pos.index,          Math.min(offset.index,    component.model.draggable.nrOfElements - 1 - pos.index));
				offset.rows     = Math.max(1 - component.model.draggable.nrOfRows,              Math.min(offset.rows,     component.model.draggable.nrOfRows - 1));
				offset.cols     = Math.max(1 - component.model.draggable.nrOfElementsPerRow,    Math.min(offset.cols,     component.model.draggable.nrOfElementsPerRow - 1));
				if((pos.row + offset.rows) == (component.model.draggable.nrOfRows - 1)){
					offset.cols = Math.min(offset.cols, ((component.model.draggable.nrOfElements - 1) % component.model.draggable.nrOfElementsPerRow) - pos.col);
				}



				// animation necessary
				if(offset.rows != 0 || offset.cols != 0 || pos.i != pos.index || dirtyIndexes.length > 0){
					var start, end, row, col, i, r, c;
					var indexes = {
						left: {},
						leftDown: {},
						right: {},
						rightUp: {},
						reset: {}
					};
					var indexesRelative = {
						left: {},
						leftDown: {},
						right: {},
						rightUp: {},
						reset: {}
					};
					var indexesLength = {
						left: 0,
						leftDown: 0,
						right: 0,
						rightUp: 0,
						reset: 0
					};
					var lastCol = component.model.draggable.nrOfElementsPerRow - 1;
					if((pos.index + offset.index) > pos.i){
						start = {
							index: pos.i,
						};
						start.row = pos.r;
						start.col = pos.c;
						end     = {
							index:  pos.index + offset.index,
							row:    pos.row + offset.rows,
							col:    pos.col + offset.cols
						};
					}
					else {
						end = {
							index: pos.i,
						};
						end.row = pos.r;
						end.col = pos.c;
						start   = {
							index:  pos.index + offset.index,
							row:    pos.row + offset.rows,
							col:    pos.col + offset.cols
						};
					}

					var index = start.index;
					var dirtyInCharge = false;
					var checkingDirties = false;
					var mappingIndex;
					var isRelative;

					for(r = start.row; r <= (end.row + dirtyIndexes.length); r++){
						for(c = 0; c < component.model.draggable.nrOfElementsPerRow; c++) {
							// within range?
							if(r == start.row && c < start.col){
								continue;
							}
							else if(r == end.row && c > end.col){
								break;
							}
							// handle dirties of last onDrag call
							else if(r > end.row){
								checkingDirties = true;
								i = dirtyIndexes[(r - end.row - 1)];
								mappingIndex = dirties[i];
								dirtyInCharge = dirties[i] !== undefined;
							}
							// set actual row and col
							else {
								// set index to actual elements index
								if(component.model.draggable.indexMapping[index] !== undefined){
									mappingIndex = component.model.draggable.indexMapping[index];
								}
								else {
									mappingIndex = index;
								}
								i = (component.model.entityListByIndex[mappingIndex] || {}).index;
								row = r;
								col = c;
							}

							if(index != pos.i){
								if(dirtyInCharge){
									if(dirties[i] !== undefined){
										// reset
										indexes.reset[i] = mappingIndex;
										indexesLength.reset++;
									}
								}
								else if(!checkingDirties){
									// reset dirty
									delete dirties[i];

									if(row < pos.row){
										if(col == lastCol){
											// left down
											indexes.leftDown[i] = mappingIndex;
											indexesLength.leftDown++;
										}
										else {
											// right
											indexes.right[i] = mappingIndex;
											indexesLength.right++;
										}
									}
									else if(row > pos.row){
										if(col == 0){
											// right up
											indexes.rightUp[i] = mappingIndex;
											indexesRelative.rightUp[i] = isRelative;
											indexesLength.rightUp++;
										}
										else {
											// left
											indexes.left[i] = mappingIndex;
											indexesLength.left++;
										}
									}
									else {
										if(col < pos.col){
											// right
											indexes.right[i] = mappingIndex;
											indexesLength.right++;
										}
										else if(col > pos.col) {
											// left
											indexes.left[i] = mappingIndex;
											indexesLength.left++;
										}
										else {
											// force original position
											indexes.reset[i] = mappingIndex;
											indexesLength.reset++;
										}
									}
								}
							}

							if(checkingDirties) break;
							index++;
						}
					}

					var properties, movement, move, selectors, selector, finalIndexOffset;
					component.model.draggable.dirtyElements[pos.index]      = {};
					// var debug = Object.keys(indexes);
					// debug.push('######');
					for(move in indexes){
						// debug.push(move);
						if(indexesLength[move] > 0){
							finalIndexOffset = 0;

							if(move === 'left'){
								finalIndexOffset    = -1;
							}
							else if(move === 'right'){
								finalIndexOffset    = 1;
							}
							else if(move === 'leftDown'){
								finalIndexOffset    = 1;
							}
							else if(move === 'rightUp'){
								finalIndexOffset    = -1;
							}

							if(move != 'reset'){
								for(i in indexes[move]){
									i = parseInt(i);
									component.model.draggable.dirtyElements[pos.index][i]                       = indexes[move][i];
									component.model.draggable.dirtyElementsMove[pos.index][indexes[move][i]]    = finalIndexOffset;
									component.model.draggable.finalDirtyElements[pos.index][indexes[move][i]]   = (i + finalIndexOffset);
								}
							}
							else {
								var lastFinalIndexOffset;
								for(i in indexes[move]) {
									i = parseInt(i);
									if(component.model.draggable.dirtyElementsMove[pos.index][indexes[move][i]] !== undefined){
										component.model.draggable.dirtyElementsMove[pos.index][indexes[move][i]] *= -1;
										lastFinalIndexOffset = component.model.draggable.dirtyElementsMove[pos.index][indexes[move][i]];
										component.model.draggable.finalDirtyElements[pos.index][indexes[move][i]] = (i + lastFinalIndexOffset);
									}
									else {
										component.model.entityListByIndex[indexes[move][i]].indexOffset = 0;
										component.model.draggable.finalDirtyElements[pos.index][indexes[move][i]] = (i + 0);
									}
								}
							}

							selectors = {};
							var indexOffset;
							for(i in indexes[move]){
								mappingIndex = indexes[move][i];
								indexOffset = (component.model.entityListByIndex[mappingIndex].indexOffset || 0) + finalIndexOffset;

								if(selectors[mappingIndex] == undefined) selectors[mappingIndex] = {};
								if(selectors[mappingIndex][indexOffset] == undefined) selectors[mappingIndex][indexOffset] = '';
								selectors[mappingIndex][indexOffset] += '[data-row-index="' + mappingIndex + '"],';
							}

							var newRow, newCol;
							for(mappingIndex in selectors){
								for(indexOffset in selectors[mappingIndex]){
									selector = selectors[mappingIndex][indexOffset];
									if(selector != ''){
										mappingIndex = parseInt(mappingIndex);
										indexOffset = parseInt(indexOffset);
										index = mappingIndex + indexOffset;
										i = mappingIndex;
										selector = selector.replace(/,$/, '');

										newRow = parseInt(index / component.model.draggable.nrOfElementsPerRow);
										newCol = (index % component.model.draggable.nrOfElementsPerRow);
										row = parseInt(i / component.model.draggable.nrOfElementsPerRow);
										col = (i % component.model.draggable.nrOfElementsPerRow);

										r = newRow - row;
										c = newCol - col;

										properties = {
											x:   (c * component.model.draggable.elements.width),
											y:    (r * component.model.draggable.elements.height)
										};

										component.model.draggable.$elements.filter(selector).each(function(){
											TweenMax.to(
												this,
												component.config.draggable.durations.moveElement,
												properties
											);
										});
									}
								}
							}
						}
					}
				}
			}
		},
		onDragEnd: function(component){
			if(!component.config.sortByDragging) return;

			if(component.model.draggable.initialized && component.model.draggable.started){
				$(this.target).removeClass('dragInCharge');
			}
		},
		onRelease: function(component){
			if(!component.config.sortByDragging) return;

			if(component.model.draggable.initialized && component.model.draggable.started){
				component.model.draggable.initialized = false;

				var pos = component.model.draggable.position || {};

				// calculate offset
				var offset = {
					rows: Math.round(this.y / component.model.draggable.elements.height),
					cols: Math.round(this.x / component.model.draggable.elements.width)
				};
				offset.index = (offset.rows * component.model.draggable.nrOfElementsPerRow);
				offset.index += offset.cols;

				// correct offset boundaries
				offset.index    = Math.max(-pos.index,          Math.min(offset.index,    component.model.draggable.nrOfElements - 1 - pos.index));
				offset.rows     = Math.max(1 - component.model.draggable.nrOfRows,              Math.min(offset.rows,     component.model.draggable.nrOfRows - 1));
				offset.cols     = Math.max(1 - component.model.draggable.nrOfElementsPerRow,    Math.min(offset.cols,     component.model.draggable.nrOfElementsPerRow - 1));
				if((pos.row + offset.rows) == (component.model.draggable.nrOfRows - 1)){
					offset.cols = Math.min(offset.cols, ((component.model.draggable.nrOfElements - 1) % component.model.draggable.nrOfElementsPerRow) - pos.col);
				}

				// update target position
				var $target = $(this.target);
				TweenMax.to(
					$target,
					component.config.draggable.durations.moveElement,
					{
						x:  (offset.cols * component.model.draggable.elements.width),
						y:  (offset.rows * component.model.draggable.elements.height),
						onComplete: function(){
							$target.css('z-index', 'initial');
							component.refresh(false);
						}
					}
				);

				// correct reset indexes if necessary
				var index, i;
				var dirtyMoves = component.model.draggable.dirtyElementsMove[pos.index];

				// update new dirties' indexes
				var targetIndex = pos.index + offset.index;
				var finalDirties = component.model.draggable.finalDirtyElements[pos.index];
				if(pos.i < targetIndex){
					for(index in finalDirties){
						i = parseInt(finalDirties[index]);
						if(i >= pos.i && i <= targetIndex){
							if(!component.model.entityListByIndex[index].indexOffset){
								component.model.entityListByIndex[index].indexOffset = 0;
							}

							if(dirtyMoves[index]){
								component.model.entityListByIndex[index].indexOffset += dirtyMoves[index];
							}

							component.model.entityListByIndex[index].index = parseInt(index) + component.model.entityListByIndex[index].indexOffset;
							component.model.draggable.indexMapping[component.model.entityListByIndex[index].index] = parseInt(index);
						}
					}
				}
				else if(pos.i > targetIndex){
					for(index in finalDirties){
						i = parseInt(finalDirties[index]);
						if(i >= targetIndex && i <= pos.i){
							component.model.entityListByIndex[index].index = parseInt(i);
							if(!component.model.entityListByIndex[index].indexOffset){
								component.model.entityListByIndex[index].indexOffset = 0;
							}

							if(dirtyMoves[index]){
								component.model.entityListByIndex[index].indexOffset += dirtyMoves[index];
							}

							component.model.entityListByIndex[index].index = parseInt(index) + component.model.entityListByIndex[index].indexOffset;
							component.model.draggable.indexMapping[component.model.entityListByIndex[index].index] = parseInt(index);
						}
					}
				}
				component.model.entityListByIndex[pos.index].index = targetIndex;
				component.model.entityListByIndex[pos.index].indexOffset = targetIndex - pos.index;
				component.model.draggable.indexMapping[targetIndex] = pos.index;

				component.refreshOrder(true);
				component.selectionChanged();
				component.model.draggable.started = false;
			}
		},



		refreshOrder: function(trustIndexFlag){
			if(!this.config.sortByDragging) return;

			// correct index positions if necessary
			var self = this;
			var entityKey, rowID;
			var orderedEntityList = {};
			var orderedEntityListByIndex = [];
			var selectedRowIDs = [];
			utils.forEach(this.model.entityListByIndex, function(entity, entityIndex){
				entity.indexOffset = 0;
				if(!trustIndexFlag) entity.index = entityIndex;
				orderedEntityListByIndex[entity.index] = entity;
			});

			utils.forEach(orderedEntityListByIndex, function(entity, entityIndex){
				rowID = ((entity || {}).attributes || {})[(entity || {}).primaryKey || 'id'];
				entityKey = `entityID_${rowID}`;
				orderedEntityList[entityKey] = orderedEntityListByIndex[entityIndex];
				selectedRowIDs.push(rowID);
			});

			self.model.entityList 			= orderedEntityList;
			self.model.entityListByIndex 	= orderedEntityListByIndex;
			self.model.selectedRowIDs 		= selectedRowIDs;
			return utils.promise.resolve();
		},

		sourceSelectionChanged: function(){
			// NOTE: overwrite this if necessary
		},

		selectionChanged: function(){
			// NOTE: overwrite this if necessary
		},

		getSelectedRowIDs: function(forceValues = false){
			if(this.config.isSelectionTarget || forceValues){
				return this.model.selectedRowIDs;
			}
		},

		getFilteredRowIDs: function(offset = 0, limit = 99999999){
			var self = this;
			self.model.preventResourceSanitationByGetFilteredRowIDs = true
			self.model.resourceFilters.offset = offset;
			self.model.resourceFilters.limit = limit;
			self.model.resourceFilters.fields = self.model.resourceFilters.fields || {}
			self.model.resourceFilters.fields.idsOnly = true
			return self.performAction('refreshResources')
				.fail(function(error){
					self.model.preventResourceSanitationByGetFilteredRowIDs = false
					self.model.resourceFilters.fields = self.model.resourceFilters.fields || {}
					self.model.resourceFilters.fields.idsOnly = false
					return utils.promise.reject(error)
				})
				.then(function(context){
					self.model.preventResourceSanitationByGetFilteredRowIDs = false
					self.model.resourceFilters.fields = self.model.resourceFilters.fields || {}
					self.model.resourceFilters.fields.idsOnly = false

					var entities = (((((context || {}).action || {}).source || {}).load || {})._response || {}).data || []
					var useSelectionObjectFormat = self.config.useSelectionObjectFormat
					var useSelectionObjectKeyAttribute = self.config.useSelectionObjectKeyAttribute
					var selectedRowIDs = []
					if(useSelectionObjectFormat){
						selectedRowIDs = {}
					}

					for(var e in entities){
						var data = entities[e] || {}
						var attributes = data.attributes || {}
						var rowID = attributes[data.primaryKey || 'id'];

						if(useSelectionObjectFormat){
							var rowKey = `${rowID}`
							if(useSelectionObjectKeyAttribute){
								rowKey = `${attributes[useSelectionObjectKeyAttribute]}`
							}
							selectedRowIDs[rowKey] = `${rowID}`;
						} else {
							selectedRowIDs.push(`${rowID}`);
						}
					}

					return utils.promise.resolve(selectedRowIDs)
				})
			;
		},

		customClickHandler: function(event){
			// NOTE: overwrite if needed. return true if default actions should be prevented.
			return false;
		}
	},

	hooks: {
		attach: function($element, options){
			this.model.$table = $element.find('table');

			// restore scroll position if necessary
			if((options || {}).refresh && this.model.lastScrollPosition > 0 && ($element || []).length > 0){
				$element.scrollTop(this.model.lastScrollPosition);
			}

			this.initDraggables($element);

			if(utils.isFunction(options.onRefreshDoneCallback)){
				options.onRefreshDoneCallback()
			}
		},

		preTabBlur: function($element, options){
			// store last scroll position on tab blur
			this.model.lastScrollPosition = $element.scrollTop();
		},

		postTabFocus: function($element, options){
			// restore scroll position if necessary
			if(this.model.lastScrollPosition > 0){
				$element.scrollTop(this.model.lastScrollPosition);
			}
		}
	}
};